/* SNKRMINT テーマ共通スクリプト（デザイン案 C）
   - ページ遷移は通常の全ページ遷移（pjax なし）
   - window.SNK にヘルパーを公開し、各テンプレートの初期化関数が利用する */
(function () {
  'use strict';

  var CFG = window.SNK_CFG || {};
  var ROUTES = CFG.routes || {};
  var ROOT = (ROUTES.root || '/').replace(/\/?$/, '/');

  /* ---------- ブランド表記 ---------- */
  var BRAND_JP = {
    'nike': 'ナイキ', 'air jordan': 'ジョーダン', 'jordan': 'ジョーダン', 'adidas': 'アディダス',
    'new balance': 'ニューバランス', 'asics': 'アシックス', 'yeezy': 'イージー', 'converse': 'コンバース',
    'on': 'オン', 'hoka': 'ホカ', 'puma': 'プーマ', 'onitsuka tiger': 'オニツカタイガー', 'vans': 'ヴァンズ',
    'reebok': 'リーボック', 'salomon': 'サロモン', 'mizuno': 'ミズノ', 'supreme': 'シュプリーム',
    'the north face': 'ザ・ノース・フェイス', 'fear of god': 'フィアオブゴッド', 'saucony': 'サッカニー', 'keen': 'キーン'
  };
  /* 検索語 → ブランドの別名（ブランド名・カタカナ表記に加えて） */
  var BRAND_ALIAS = {
    'air jordan': ['jordan', 'ジョーダン', 'エアジョーダン', 'エア ジョーダン'],
    'new balance': ['newbalance', 'nb', 'ニューバランス'],
    'onitsuka tiger': ['onitsuka', 'onitsukatiger', 'オニツカ', 'オニツカタイガー'],
    'on': ['on running', 'オンランニング'],
    'hoka': ['hoka one one', 'ホカオネオネ'],
    'vans': ['バンズ'],
    'asics': ['アシックス'],
    'yeezy': ['イージー'],
    'salomon': ['サロモン'],
    'mizuno': ['ミズノ']
  };
  function brandName(v) { v = String(v || ''); return v.toLowerCase() === 'on' ? 'On' : v; }
  function brandJp(v) { return BRAND_JP[String(v || '').toLowerCase()] || ''; }
  function normQ(s) {
    s = String(s == null ? '' : s);
    if (s.normalize) s = s.normalize('NFKC');
    return s.toLowerCase().replace(/[\s\u3000]+/g, ' ').trim();
  }
  /* 検索語がブランド名だけなら { v: ブランド, u: 一覧 URL } を返す（layout/theme.liquid の SNK_CFG.brands） */
  function brandFor(q) {
    q = normQ(q);
    if (!q) return null;
    var list = CFG.brands || [];
    for (var i = 0; i < list.length; i++) {
      var v = String(list[i].v || ''), k = v.toLowerCase();
      var keys = [k, k.replace(/\s+/g, ''), brandJp(v).toLowerCase()].concat(BRAND_ALIAS[k] || []);
      if (keys.indexOf(q) > -1) return list[i];
    }
    return null;
  }
  /* 品番の表記ゆれ候補（ハイフンなし → ハイフンあり、スペース → ハイフン、ハイフンあり → なし）。品番らしくなければ [] */
  function codeVariants(q) {
    var s = String(q || '');
    if (s.normalize) s = s.normalize('NFKC');
    s = s.trim().toUpperCase();
    var out = [];
    if (/^[A-Z0-9]{4,10}[\s\u3000]+\d{2,3}$/.test(s)) out.push(s.replace(/[\s\u3000]+/, '-'));
    else if (/^[A-Z0-9]{3,10}-[A-Z0-9]{2,4}$/.test(s)) out.push(s.replace('-', ''));
    else if (/^[A-Z0-9]{7,13}$/.test(s) && /\d/.test(s)) {
      if (/\d{3}$/.test(s)) out.push(s.slice(0, -3) + '-' + s.slice(-3));
      if (/\d{2}$/.test(s)) out.push(s.slice(0, -2) + '-' + s.slice(-2));
    }
    return out;
  }
  /* 商品検索の URL（vendor を渡すとそのブランドに限定） */
  function searchUrl(kw, vendor) {
    var q = (vendor ? 'vendor:"' + String(vendor).replace(/"/g, '') + '" ' : '') + String(kw || '').trim();
    return url('search') + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
  }
  /* 検索候補（templates/search.suggest.liquid の JSON：{ count, items }） */
  function suggest(q, signal) {
    var u = url('search') + '?type=product&options%5Bprefix%5D=last&view=suggest&q=' + encodeURIComponent(q);
    return fetch(u, { credentials: 'same-origin', signal: signal })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }

  /* ---------- 汎用 ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function yen(n) { return '¥' + Math.round(Number(n) || 0).toLocaleString('ja-JP'); }
  function img(u, w) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 600);
  }
  function qs() { return new URLSearchParams(location.search); }
  function url(path) { return ROOT + String(path).replace(/^\//, ''); }

  /* ---------- お気に入り（localStorage） ---------- */
  var FAV_KEY = 'snkrmint_fav';
  function getFav() {
    try { var a = JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function setFav(a) {
    var ok = true;
    try { localStorage.setItem(FAV_KEY, JSON.stringify(a)); } catch (e) { ok = false; }
    renderFavBadge();
    return ok;
  }
  function isFav(h) { return getFav().indexOf(h) > -1; }
  function toggleFav(h) {
    var f = getFav(), i = f.indexOf(h);
    if (i > -1) f.splice(i, 1); else f.push(h);
    if (!setFav(f)) return null; /* 保存できない環境（プライベートモード等） */
    return i < 0;
  }
  function renderFavBadge() {
    var n = getFav().length;
    document.querySelectorAll('[data-fav-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
  }
  function syncFavButtons(root) {
    var f = getFav();
    (root || document).querySelectorAll('[data-fav]').forEach(function (b) {
      var on = f.indexOf(b.getAttribute('data-fav')) > -1;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------- カート件数 ---------- */
  function renderCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
  }
  function refreshCart() {
    return fetch(url('cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) renderCartCount(c.item_count); return c; })
      .catch(function () { return null; });
  }

  /* ---------- トースト ---------- */
  var toastTimer;
  function toast(msg, isErr) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.toggle('err', !!isErr);
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, isErr ? 4000 : 2400);
  }

  /* ---------- 営業日カレンダー（当月・翌月） ---------- */
  var HOLIDAYS = [
    '2026-01-01', '2026-01-12', '2026-02-11', '2026-02-23', '2026-03-20', '2026-04-29', '2026-05-03', '2026-05-04',
    '2026-05-05', '2026-05-06', '2026-07-20', '2026-08-11', '2026-09-21', '2026-09-22', '2026-09-23', '2026-10-12',
    '2026-11-03', '2026-11-23',
    '2027-01-01', '2027-01-11', '2027-02-11', '2027-02-23', '2027-03-21', '2027-03-22', '2027-04-29', '2027-05-03',
    '2027-05-04', '2027-05-05', '2027-07-19', '2027-08-11', '2027-09-20', '2027-09-23', '2027-10-11', '2027-11-03',
    '2027-11-23'
  ];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function jstNow() {
    /* 閲覧者の端末時刻に依らず日本時間の日付で描画する */
    var d = new Date();
    return new Date(d.getTime() + (d.getTimezoneOffset() + 540) * 60000);
  }
  function calTable(y, m, extra, today) {
    var first = new Date(y, m, 1).getDay(), days = new Date(y, m + 1, 0).getDate();
    var h = '<table class="cal"><caption>' + y + '年' + (m + 1) + '月</caption><thead><tr>' +
      '日月火水木金土'.split('').map(function (d) { return '<th scope="col">' + d + '</th>'; }).join('') +
      '</tr></thead><tbody><tr>';
    for (var i = 0; i < first; i++) h += '<td></td>';
    for (var d = 1; d <= days; d++) {
      var wd = (first + d - 1) % 7;
      var key = y + '-' + pad(m + 1) + '-' + pad(d);
      var cls = [];
      if (wd === 0 || wd === 6 || HOLIDAYS.indexOf(key) > -1 || extra.indexOf(key) > -1) cls.push('off');
      if (today && d === today) cls.push('today');
      h += '<td' + (cls.length ? ' class="' + cls.join(' ') + '"' : '') + '>' + d + '</td>';
      if (wd === 6 && d < days) h += '</tr><tr>';
    }
    var rest = (7 - (first + days) % 7) % 7;
    for (var j = 0; j < rest; j++) h += '<td></td>';
    return h + '</tr></tbody></table>';
  }
  function renderCal() {
    var el = document.getElementById('cal');
    if (!el) return;
    var extra = String(el.getAttribute('data-extra') || '').split(/[\s,、]+/).filter(Boolean);
    var now = jstNow(), y = now.getFullYear(), m = now.getMonth();
    var ny = m === 11 ? y + 1 : y, nm = (m + 1) % 12;
    el.innerHTML = calTable(y, m, extra, now.getDate()) + calTable(ny, nm, extra, 0);
  }

  /* ---------- ヘッダー：ブランド付き検索 ----------
     ブランドを選ぶ → そのブランドの一覧（サーバー側でページ送り）へ。
     ブランド＋キーワード → vendor:"ブランド" を付けた商品検索。ブランド名だけの入力 → ブランド一覧へ直行。 */
  function initSearch() {
    document.querySelectorAll('form[data-search]').forEach(function (form) {
      var sel = form.querySelector('select'), input = form.querySelector('input[name="q"]');
      function brandUrl(v) {
        var o = sel && [].filter.call(sel.options, function (x) { return x.value === v; })[0];
        return (o && o.getAttribute('data-url')) || (brandFor(v) || {}).u || '';
      }
      if (sel) {
        /* 現在のブランド一覧・ブランド検索ならブランドを選択状態にする */
        var m = /vendor:"([^"]+)"/.exec(qs().get('q') || '');
        var cur = m ? m[1] : (document.querySelector('[data-current-vendor]') || { getAttribute: function () { return ''; } }).getAttribute('data-current-vendor');
        if (cur) {
          for (var i = 0; i < sel.options.length; i++) {
            if (sel.options[i].value.toLowerCase() === String(cur).toLowerCase()) { sel.selectedIndex = i; break; }
          }
        }
        if (m && input) input.value = (qs().get('q') || '').replace(m[0], '').trim();
        sel.addEventListener('change', function () {
          if (!sel.value) return;
          var kw = input ? input.value.trim() : '';
          if (kw) return; /* キーワード入力中は送信時にまとめて絞り込む */
          var u = brandUrl(sel.value);
          if (u) location.href = u;
        });
      }
      form.addEventListener('submit', function (e) {
        var kw = input ? input.value.trim() : '';
        var v = sel && sel.value;
        if (v) {
          e.preventDefault();
          location.href = kw ? searchUrl(kw, v) : (brandUrl(v) || searchUrl(v));
          return;
        }
        if (!kw) { e.preventDefault(); return; }
        var b = brandFor(kw);
        if (b) { e.preventDefault(); location.href = b.u; }
      });
      if (input) initSuggest(form, input);
    });
  }

  /* ---------- ヘッダー：品番の候補（数字を含む 3 文字以上の入力で表示） ---------- */
  function initSuggest(form, input) {
    var box = document.createElement('div');
    var id = 'sg' + Math.random().toString(36).slice(2, 8);
    box.className = 'sg'; box.id = id; box.hidden = true;
    form.parentNode.insertBefore(box, form.nextSibling);
    input.setAttribute('aria-controls', id);
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    var timer, ctl, last = '';
    function hide() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function place() {
      box.style.left = form.offsetLeft + 'px';
      box.style.top = (form.offsetTop + form.offsetHeight + 2) + 'px';
      box.style.width = form.offsetWidth + 'px';
    }
    function row(p) {
      return '<a class="sg-i" href="' + esc(p.url) + '">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="sg-noimg"></span>') +
        '<span class="sg-t"><b>' + esc(p.code) + '</b>' + esc(p.title) + '</span>' +
        '<span class="sg-p">' + (p.price ? esc(p.price) + (p.range ? '〜' : '') : '―') + '</span></a>';
    }
    function show(q, j) {
      var items = (j && j.items) || [];
      if (!items.length) { hide(); return; }
      box.innerHTML = '<p class="sg-h">品番の候補</p>' + items.slice(0, 6).map(row).join('') +
        '<a class="sg-all" href="' + esc(searchUrl(q)) + '">「' + esc(q) + '」の検索結果をすべて見る（' + j.count + '件）</a>';
      place();
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function run(q) {
      if (ctl && ctl.abort) ctl.abort();
      ctl = window.AbortController ? new AbortController() : null;
      var sig = ctl ? ctl.signal : undefined;
      suggest(q, sig).then(function (j) {
        if (input.value.trim() !== q) return;
        if (j && j.count > 0) return show(q, j);
        var alt = codeVariants(q)[0];
        if (!alt) return hide();
        return suggest(alt, sig).then(function (j2) { if (input.value.trim() === q) show(alt, j2); });
      }).catch(function () { /* 中断・失敗時は何も出さない */ });
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q === last) return;
      last = q;
      if (q.length < 3 || !/\d/.test(q) || (form.querySelector('select') || {}).value) { hide(); return; }
      timer = setTimeout(function () { run(q); }, 250);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' && !box.hidden) { var f = box.querySelector('a'); if (f) { e.preventDefault(); f.focus(); } }
      if (e.key === 'Escape') hide();
    });
    box.addEventListener('keydown', function (e) {
      var links = [].slice.call(box.querySelectorAll('a')), i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i < links.length - 1) { e.preventDefault(); links[i + 1].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); if (i > 0) links[i - 1].focus(); else input.focus(); }
      if (e.key === 'Escape') { hide(); input.focus(); }
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target) && e.target !== input) hide(); });
    window.addEventListener('resize', function () { if (!box.hidden) place(); });
  }

  /* ---------- 商品カードの遅延表示（トップの新着・ブランド別） ----------
     [data-cards-src] の URL に view=cards を付けて取得（templates/collection.cards.liquid）。
     並び順（新着順など）はサーバー側の sort_by で決まる。失敗時は「もっと見る」リンクのみ残る。 */
  function loadCards(el) {
    if (!el || el.getAttribute('data-cards-state')) return;
    var src = el.getAttribute('data-cards-src');
    if (!src) return;
    el.setAttribute('data-cards-state', 'loading');
    var limit = Number(el.getAttribute('data-cards-limit')) || 10;
    fetch(src + (src.indexOf('?') > -1 ? '&' : '?') + 'view=cards', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var t = document.createElement('template');
        t.innerHTML = html;
        var cards = [].slice.call(t.content.querySelectorAll('.card')).slice(0, limit);
        el.innerHTML = '';
        cards.forEach(function (c) { el.appendChild(c); });
        if (!cards.length) el.innerHTML = '<p class="tab-empty">現在お取り寄せ可能な商品はありません。</p>';
        el.setAttribute('data-cards-state', 'done');
        syncFavButtons(el);
      })
      .catch(function () {
        el.innerHTML = '<p class="tab-empty">商品を読み込めませんでした。「もっと見る」から一覧をご覧ください。</p>';
        el.setAttribute('data-cards-state', 'error');
      });
  }
  function initCards() {
    document.querySelectorAll('[data-cards-src]').forEach(function (el) {
      if (!el.hidden && !el.closest('[hidden]')) loadCards(el);
    });
  }

  /* ---------- スマホメニュー ---------- */
  function initSpNav() {
    var nav = document.getElementById('spNav'), dim = document.getElementById('spDim');
    var openers = document.querySelectorAll('[data-sp-open]');
    if (!nav) return;
    function set(open) {
      nav.classList.toggle('open', open);
      if (dim) dim.classList.toggle('open', open);
      nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) { var f = nav.querySelector('button, a'); if (f) f.focus(); }
    }
    openers.forEach(function (b) { b.addEventListener('click', function () { set(true); }); });
    nav.querySelectorAll('[data-sp-close]').forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    if (dim) dim.addEventListener('click', function () { set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('open')) set(false); });
  }

  /* ---------- グローバルナビの現在地 ---------- */
  function markNav() {
    var here = location.pathname + location.search;
    document.querySelectorAll('.gnav a[href]').forEach(function (a) {
      var u;
      try { u = new URL(a.href, location.href); } catch (e) { return; }
      if (u.origin !== location.origin) return;
      var target = u.pathname + u.search;
      if (target === here || (u.search === '' && u.pathname === location.pathname && u.pathname !== '/' && !location.search)) {
        a.classList.add('on');
        a.setAttribute('aria-current', 'page');
      }
    });
  }

  /* ---------- カート追加後のミニ通知 ---------- */
  function miniCart(opts) {
    var box = document.getElementById('miniCart');
    if (!box) { toast(opts.error || 'カートに追加しました', !!opts.error); return; }
    var body = box.querySelector('[data-mc-body]'), ttl = box.querySelector('[data-mc-ttl]');
    box.classList.toggle('err', !!opts.error);
    if (opts.error) {
      ttl.textContent = 'カートに追加できませんでした';
      body.innerHTML = '<p class="mc-msg">' + esc(opts.error) + '</p>';
    } else {
      ttl.textContent = 'カートに追加しました';
      body.innerHTML = '<div class="mc-item">' + (opts.image ? '<img src="' + esc(opts.image) + '" alt="" width="64" height="64">' : '') +
        '<div><b>' + esc(opts.title) + '</b>' + (opts.variant ? esc(opts.variant) + ' ／ ' : '') + '数量 ' + esc(opts.quantity) + '</div></div>';
    }
    box.querySelector('[data-mc-btns]').hidden = !!opts.error;
    box.classList.add('open');
    var close = box.querySelector('[data-mc-close]');
    if (close) close.focus();
    clearTimeout(miniCart._t);
    if (!opts.error) miniCart._t = setTimeout(function () { box.classList.remove('open'); }, 8000);
  }
  function initMiniCart() {
    var box = document.getElementById('miniCart');
    if (!box) return;
    box.querySelector('[data-mc-close]').addEventListener('click', function () { box.classList.remove('open'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') box.classList.remove('open'); });
  }

  /* /cart/add.js を呼ぶ。成功時は追加された行、失敗時は Error(message) で reject */
  function addToCart(id, quantity) {
    return fetch(url('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || j.status) {
          /* Shopify の description は在庫数を含むことがあるため表示しない（在庫件数は非表示の方針） */
          var st = Number(j.status) || r.status;
          throw new Error(st === 422
            ? 'ご指定のサイズ・数量はただいまカートに追加できません。数量を減らすか、別のサイズをお選びください。'
            : 'カートに追加できませんでした。時間をおいて再度お試しください。');
        }
        return j;
      });
    }, function () {
      throw new Error('通信エラーが発生しました。電波状況をご確認のうえ、再度お試しください。');
    });
  }

  /* ---------- お気に入りボタン（委譲） ---------- */
  function initFavClicks() {
    document.addEventListener('click', function (e) {
      var f = e.target.closest ? e.target.closest('[data-fav]') : null;
      if (!f) return;
      e.preventDefault();
      var on = toggleFav(f.getAttribute('data-fav'));
      if (on === null) { toast('お気に入りを保存できませんでした。ブラウザの設定をご確認ください。', true); return; }
      document.querySelectorAll('[data-fav="' + f.getAttribute('data-fav').replace(/"/g, '\\"') + '"]').forEach(function (b) {
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var lbl = b.querySelector('[data-fav-label]');
        if (lbl) lbl.textContent = on ? 'お気に入り済み' : 'お気に入り';
      });
      toast(on ? 'お気に入りに追加しました' : 'お気に入りから削除しました');
      document.dispatchEvent(new CustomEvent('snk:fav', { detail: { handle: f.getAttribute('data-fav'), on: on } }));
    });
  }

  /* ---------- タブ（トップ ブランド別） ---------- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
      var btns = wrap.querySelectorAll('[role="tab"]');
      var more = wrap.querySelector('[data-tab-more]');
      function show(btn) {
        btns.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) { panel.hidden = !on; if (on) loadCards(panel); }
        });
        if (more && btn.getAttribute('data-more')) more.href = btn.getAttribute('data-more');
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { show(b); });
        b.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight') n = btns[(i + 1) % btns.length];
          if (k === 'ArrowLeft') n = btns[(i - 1 + btns.length) % btns.length];
          if (n) { e.preventDefault(); n.focus(); show(n); }
        });
      });
    });
  }

  /* ---------- トップ：横スクロールの商品列（sections/c-product-rail） ----------
     左右ボタンで約 1 画面分スクロール。端ではボタンを隠す。スクロールできない幅ではボタンを出さない。 */
  function initRails() {
    document.querySelectorAll('[data-rail]').forEach(function (box) {
      var list = box.querySelector('[data-rail-list]');
      var prev = box.querySelector('[data-rail-prev]'), next = box.querySelector('[data-rail-next]');
      if (!list || !prev || !next) return;
      function update() {
        var max = list.scrollWidth - list.clientWidth;
        prev.hidden = list.scrollLeft <= 4;
        next.hidden = max <= 4 || list.scrollLeft >= max - 4;
      }
      function go(dir) { list.scrollBy({ left: dir * Math.max(list.clientWidth * 0.9, 160), behavior: 'smooth' }); }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- 紹介文の折りたたみ（[data-clamp]：3 行を超える場合のみ「続きを読む」） ---------- */
  function initClamp() {
    document.querySelectorAll('[data-clamp]').forEach(function (wrap) {
      var body = wrap.querySelector('[data-clamp-body]'), btn = wrap.querySelector('[data-clamp-toggle]');
      if (!body || !btn) return;
      body.classList.add('is-clamped');
      if (body.scrollHeight <= body.clientHeight + 2) { body.classList.remove('is-clamped'); return; }
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = body.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? '閉じる' : '続きを読む';
      });
    });
  }

  window.SNK = {
    cfg: CFG, url: url, esc: esc, yen: yen, img: img, qs: qs,
    brandName: brandName, brandJp: brandJp, brandFor: brandFor, codeVariants: codeVariants, searchUrl: searchUrl, suggest: suggest,
    getFav: getFav, isFav: isFav, toggleFav: toggleFav, syncFavButtons: syncFavButtons, loadCards: loadCards,
    toast: toast, miniCart: miniCart, addToCart: addToCart, refreshCart: refreshCart, renderCartCount: renderCartCount
  };

  function init() {
    initSearch();
    initSpNav();
    markNav();
    initMiniCart();
    initFavClicks();
    initTabs();
    initCards();
    initRails();
    renderFavBadge();
    syncFavButtons();
    renderCal();
    initClamp();
    /* bfcache から戻った場合もカート件数を最新化 */
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
    document.dispatchEvent(new CustomEvent('snk:ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
